import {z} from 'zod';

import {BaseVoidResponseSchema} from '@dms/api/shared';

const SpaceBodySchema = z.object({
  isActive: z.boolean(),
  name: z.string(),
  assignWarehouses: z.array(z.string()),
});

/**
 * GET spaces
 */
export const GetSpacesRequestSchema = z.object({
  warehouseId: z.string(),
});
export type GetSpacesRequest = z.infer<typeof GetSpacesRequestSchema>;

export const GetSpacesResponseSchema = z.array(
  SpaceBodySchema.extend({
    spaceId: z.string(),
  })
);
export type GetSpacesResponse = z.infer<typeof GetSpacesResponseSchema>;

/**
 * GET space
 */
export const GetSpaceRequestSchema = z.object({
  spaceId: z.string(),
});
export type GetSpaceRequest = z.infer<typeof GetSpaceRequestSchema>;

export const GetSpaceResponseSchema = SpaceBodySchema;
export type GetSpaceResponse = z.infer<typeof GetSpaceResponseSchema>;

/**
 * POST space
 */
export const PostSpaceRequestSchema = SpaceBodySchema;
export type PostSpaceRequest = z.infer<typeof PostSpaceRequestSchema>;

export const PostSpaceResponseSchema = z.object({
  spaceId: z.string(),
});
export type PostSpaceResponse = z.infer<typeof PostSpaceResponseSchema>;

/**
 * PATCH space
 */
export const PatchSpaceRequestSchema = z.object({
  spaceId: z.string(),
  body: SpaceBodySchema,
});
export type PatchSpaceRequest = z.infer<typeof PatchSpaceRequestSchema>;

export const PatchSpaceResponseSchema = BaseVoidResponseSchema;
export type PatchSpaceResponse = z.infer<typeof PatchSpaceResponseSchema>;

/**
 * DELETE spaces
 */
export const DeleteSpacesRequestSchema = z.object({
  body: z.object({
    spaceIds: z.array(z.string()),
  }),
});
export type DeleteSpacesRequest = z.infer<typeof DeleteSpacesRequestSchema>;

export const DeleteSpacesResponseSchema = BaseVoidResponseSchema;
export type DeleteSpacesResponse = z.infer<typeof DeleteSpacesResponseSchema>;
